export const DOCUMENT_ID_FILTER = 'Document Id';
